module.exports = __webpack_public_path__ + "static/astridBg-40b071fb59391f3c54e938fdd077505c.jpg";